import useStateHelper from '@/views/shared/useStateHelper';

const handlers = {
  changeProducer(state, action) {
    const {producerId, producerName, producerFullName} = action.newProducer;
    return {
      ...state,
      producerId,
      producerName,
      producerFullName,
    };
  },
};
const [ProducerStateProvider, useProducerCtx] = useStateHelper({handlers});
export {ProducerStateProvider, useProducerCtx};
